package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.navigation.BusinessSidebarTab
import com.arena_web.ui.layouts.BusinessPageLayout
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

@Page("/schedule")
@Composable
fun SchedulePage() {
    val t = LocalAppStrings.current
    BusinessPageLayout(activeTab = BusinessSidebarTab.Schedule) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .sPadding(24, 40)
        ) {
            SpanText(
                t.pageScheduleTitle,
                modifier = Modifier
                    .sFontSize(28)
                    .fontWeight(AppTypography.SemiBold)
                    .color(com.arena_web.ui.theme.ThemeVars.Text1)
            )

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .sHeight(400)
                    .sMarginTop(24)
                    .sBorderRadius(22)
                    .styleModifier {
                        property("background",
                            "linear-gradient(184deg, rgba(60, 121, 241, 0.08) 20%, rgba(5, 4, 12, 0.01) 109%)")
                        property("border", "1px dashed rgba(41, 52, 138, 0.2)")
                    },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    t.pageScheduleComingSoon,
                    modifier = Modifier
                        .sFontSize(16)
                        .fontWeight(AppTypography.Medium)
                        .color(com.arena_web.ui.theme.ThemeVars.Text3)
                )
            }
        }
    }
}
